<div class="purple-fit-tab">
  <ul class="purple-fit-tab-menu" nz-menu nzMode="horizontal">
  @for (menuItem of layoutSvc.activeMenu; track $index) {
    @if(layoutSvc.showMenu(menuItem.maxLevel, menuItem.minLevel, menuItem.exlusiveRoles, menuItem.excludeRoles)){
      <li [style.width.%]="100/layoutSvc.activeMenu.length" class="purple-fit-tab-menu-item" nz-menu-item routerLinkActive="ant-menu-item-selected" [routerLink]="menuItem.relativeLink"
      [nzSelected]="layoutSvc.checkIsCurrentMenu(menuItem.id)" [queryParams]="menuItem.queryParams">
      <div class="purple-fit-tab-menu-icon-container">
        <span class="purple-fit-tab-menu-icon {{menuItem.iconName}}"></span>
      </div>
      <p class="purple-fit-tab-menu-text">{{menuItem.name}}</p>
    </li>
    }
  }
</ul>
</div>